@if (supplierPreviews.length > 0) {
  @if (!showExtended) {
    <span>
      {{ supplierPreviews[0].displayName | stringPreview: 30 }}
      @if (supplierPreviews.length > 1) {
        <span
          class="text-primary hoverable cursor-pointer"
          (click)="showExtended = true; $event.stopPropagation()"
          >
          {{ 'und \{\{value\}\} weitere' | translate: { value: supplierPreviews.length - 1 } }}
        </span>
      }
    </span>
  }
  @if (showExtended) {
    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col">
            <ul class="list-group">
              @for (supplier of supplierPreviews; track supplier) {
                <li class="list-group-item">
                  {{ supplier.displayName }},
                  @if (
                    supplier?.contact && (supplier.contact.firstName || supplier.contact.surName)) {
                    <span
                      >
                      {{ supplier.contact | person }}
                    </span>
                  } @else {
                    {{ 'Standard Ansprechpartner' | translate }}
                  }
                </li>
              }
            </ul>
          </div>
        </div>
        <div class="row justify-content-end">
          <div class="col-auto">
            <span class="text-primary cursor-pointer hoverable" (click)="showExtended = false">
              {{ 'weniger anzeigen' | translate }}
            </span>
          </div>
        </div>
      </div>
    </div>
  }
}
